exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.banner.vux-slider > .vux-indicator,\n.banner.vux-slider .vux-indicator-right {\n  bottom: 0;\n  right: 50%;\n  -webkit-transform: translateX(50%);\n          transform: translateX(50%);\n}\n.banner.vux-slider > .vux-indicator > a > .vux-icon-dot,\n.banner.vux-slider .vux-indicator-right > a > .vux-icon-dot {\n  background-color: rgba(0, 0, 0, 0.4);\n}\n.banner.vux-slider > .vux-indicator > a > .vux-icon-dot.active,\n.banner.vux-slider .vux-indicator-right > a > .vux-icon-dot.active {\n  background-color: #ffffff;\n}\n", ""]);

// exports
